/**
 * @generated SignedSource<<b6d4d21b920b4b54385c439d1facbeb2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type ZakekeEnvironment = "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type productSidePanelContent_ProductQuery$variables = {
  id: string;
  skipProductAreaBackgroundRules: boolean;
  skipProductMoqRules: boolean;
  skipProductPrintTypes: boolean;
  skipProductQuoteRule: boolean;
  skipProductScenes: boolean;
};
export type productSidePanelContent_ProductQuery$data = {
  readonly model: {
    readonly additionalCodes: ReadonlyArray<{
      readonly code: string;
      readonly merchantProductName: string;
      readonly salesChannel: {
        readonly detail: {
          readonly id: string;
          readonly properties: {
            readonly name: string | null;
          } | null;
        } | null;
        readonly ecommerceSettings: {
          readonly definitiveUrl: string | null;
          readonly ecommerceName: ECommerce;
          readonly hasProductsApi: boolean;
          readonly productsApi: string | null;
          readonly remoteUrl: string | null;
        } | null;
        readonly id: string;
      };
      readonly salesChannelID: string;
    }>;
    readonly areaBackgroundRules?: {
      readonly productRule: {
        readonly colorList: string | null;
      } | null;
    } | null;
    readonly canAddAdditionalCode: boolean;
    readonly code: string;
    readonly id: string;
    readonly modelColorsCompressed: string;
    readonly modelID: number;
    readonly moqRules?: {
      readonly productRule: {
        readonly id: string;
        readonly moqRuleID: number;
        readonly name: string;
      } | null;
    } | null;
    readonly name: string;
    readonly printTypes?: ReadonlyArray<{
      readonly name: string;
      readonly printTypeID: number;
      readonly printTypeRestrictions: {
        readonly disableSellerImages: boolean | null;
        readonly disableUserImages: boolean | null;
      } | null;
    }>;
    readonly provider: ProductProvider;
    readonly quoteRule?: {
      readonly allowAddToCart: boolean;
      readonly formControlsData: string | null;
      readonly id: string;
      readonly isValidForAllProducts: boolean;
      readonly name: string | null;
      readonly notifyEmailList: string | null;
      readonly products: ReadonlyArray<number> | null;
      readonly quoteRuleID: number;
    } | null;
    readonly salesChannel: {
      readonly detail: {
        readonly id: string;
        readonly properties: {
          readonly name: string | null;
        } | null;
      } | null;
      readonly ecommerceSettings: {
        readonly definitiveUrl: string | null;
        readonly ecommerceName: ECommerce;
        readonly hasProductsApi: boolean;
        readonly productsApi: string | null;
        readonly remoteUrl: string | null;
      } | null;
      readonly id: string;
    };
    readonly scenes?: ReadonlyArray<{
      readonly sceneID: any;
    }>;
    readonly smallImageUrl: string;
    readonly sourceProductTemplateID: number | null;
    readonly statusID: number;
    readonly zakekeEnvironment: ZakekeEnvironment;
  } | null;
};
export type productSidePanelContent_ProductQuery = {
  response: productSidePanelContent_ProductQuery$data;
  variables: productSidePanelContent_ProductQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipProductAreaBackgroundRules"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipProductMoqRules"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipProductPrintTypes"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipProductQuoteRule"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipProductScenes"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelID",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusID",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smallImageUrl",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zakekeEnvironment",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAddAdditionalCode",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceProductTemplateID",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelColorsCompressed",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannelDetail",
  "kind": "LinkedField",
  "name": "detail",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesChannelDetailProperties",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        (v9/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productsApi",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasProductsApi",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "definitiveUrl",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannel",
  "kind": "LinkedField",
  "name": "salesChannel",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        (v19/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/),
        (v23/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelID",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantProductName",
  "storageKey": null
},
v27 = {
  "condition": "skipProductPrintTypes",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelPrintType",
      "kind": "LinkedField",
      "name": "printTypes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "printTypeID",
          "storageKey": null
        },
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "PartPrintTypeRestriction",
          "kind": "LinkedField",
          "name": "printTypeRestrictions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "disableSellerImages",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "disableUserImages",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v28 = {
  "condition": "skipProductScenes",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelScene",
      "kind": "LinkedField",
      "name": "scenes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sceneID",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorList",
  "storageKey": null
},
v30 = {
  "condition": "skipProductQuoteRule",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuoteRule",
      "kind": "LinkedField",
      "name": "quoteRule",
      "plural": false,
      "selections": [
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quoteRuleID",
          "storageKey": null
        },
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isValidForAllProducts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formControlsData",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowAddToCart",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notifyEmailList",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "products",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v31 = {
  "condition": "skipProductMoqRules",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MoqRules",
      "kind": "LinkedField",
      "name": "moqRules",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MoqRule",
          "kind": "LinkedField",
          "name": "productRule",
          "plural": false,
          "selections": [
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "moqRuleID",
              "storageKey": null
            },
            (v9/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannel",
  "kind": "LinkedField",
  "name": "salesChannel",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v18/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        (v19/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/),
        (v23/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_ProductQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v24/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCode",
            "kind": "LinkedField",
            "name": "additionalCodes",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          },
          (v27/*: any*/),
          (v28/*: any*/),
          {
            "condition": "skipProductAreaBackgroundRules",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AreaBackgroundRules",
                "kind": "LinkedField",
                "name": "areaBackgroundRules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AreaBackgroundRule",
                    "kind": "LinkedField",
                    "name": "productRule",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v30/*: any*/),
          (v31/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_ProductQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v32/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCode",
            "kind": "LinkedField",
            "name": "additionalCodes",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v32/*: any*/)
            ],
            "storageKey": null
          },
          (v27/*: any*/),
          (v28/*: any*/),
          {
            "condition": "skipProductAreaBackgroundRules",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AreaBackgroundRules",
                "kind": "LinkedField",
                "name": "areaBackgroundRules",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AreaBackgroundRule",
                    "kind": "LinkedField",
                    "name": "productRule",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v30/*: any*/),
          (v31/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f72421db5bcf8fdc0f9ced7d28300177",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_ProductQuery",
    "operationKind": "query",
    "text": "query productSidePanelContent_ProductQuery(\n  $id: ID!\n  $skipProductPrintTypes: Boolean!\n  $skipProductScenes: Boolean!\n  $skipProductAreaBackgroundRules: Boolean!\n  $skipProductQuoteRule: Boolean!\n  $skipProductMoqRules: Boolean!\n) {\n  model(id: $id) {\n    id\n    modelID\n    name\n    code\n    statusID\n    smallImageUrl\n    zakekeEnvironment\n    provider\n    canAddAdditionalCode\n    sourceProductTemplateID\n    modelColorsCompressed\n    salesChannel {\n      id\n      detail {\n        id\n        properties {\n          name\n        }\n      }\n      ecommerceSettings {\n        ecommerceName\n        remoteUrl\n        productsApi\n        hasProductsApi\n        definitiveUrl\n        id\n      }\n    }\n    additionalCodes {\n      code\n      salesChannelID\n      merchantProductName\n      salesChannel {\n        id\n        detail {\n          id\n          properties {\n            name\n          }\n        }\n        ecommerceSettings {\n          ecommerceName\n          remoteUrl\n          productsApi\n          hasProductsApi\n          definitiveUrl\n          id\n        }\n      }\n    }\n    printTypes @skip(if: $skipProductPrintTypes) {\n      printTypeID\n      name\n      printTypeRestrictions {\n        disableSellerImages\n        disableUserImages\n      }\n    }\n    scenes @skip(if: $skipProductScenes) {\n      sceneID\n    }\n    areaBackgroundRules @skip(if: $skipProductAreaBackgroundRules) {\n      productRule {\n        colorList\n        id\n      }\n    }\n    quoteRule @skip(if: $skipProductQuoteRule) {\n      id\n      quoteRuleID\n      name\n      isValidForAllProducts\n      formControlsData\n      allowAddToCart\n      notifyEmailList\n      products\n    }\n    moqRules @skip(if: $skipProductMoqRules) {\n      productRule {\n        id\n        moqRuleID\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5378b6880c3bd52202f04f66b255b96b";

export default node;
